import * as React from 'react';
import { observer } from 'mobx-react';
import Link from '@src/components/link';

const styles = require('../../index.less');

const Audition = ({ store }) => {
  store.use();
  return (
    <React.Fragment>
      <div className="main-layer-163" />
      {/* <div className="main-layer-111" /> */}
      <Link
        className="main-layer-166"
        onClick={() => {
          // store.onMeidaPageClick(routeConfigs.AUDITION_VIDEO.getFormatPath(), '视频');
          store.onMeidaPageClick('audition-video', '视频');
        }}
      />
      <Link
        className="main-layer-165"
        onClick={() => {
          // store.onMeidaPageClick(routeConfigs.AUDITION_IMAGE.getFormatPath(), '图像');
          store.onMeidaPageClick('audition-image', '图像');
        }}
      />
      <Link
        className="main-layer-164"
        onClick={() => {
          // store.onMeidaPageClick(routeConfigs.AUDITION_AUDIO.getFormatPath(), '音频');
          store.onMeidaPageClick('audition-audio', '音频');
        }}
      />
      <div className="main-layer-167" />
    </React.Fragment>
  );
};

export default observer(Audition);
